import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService } from './_services/auth.service'
import { Title } from '@angular/platform-browser';
import { Compiler } from '@angular/core';
import { AppConfig } from './_helpers/appconfig.service';
import { HostListener } from '@angular/core';
import { BackFilterService } from './_services/back-filter.service';
import { DataService } from './_helpers';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'KCMS website';
  hideElement = true;
  isNewArrival: string;
  private destroy$ = new Subject<void>();
  designVersion: string;
  hideHeaderForComponent = false;

  constructor(
    public auth: AuthService
    , private router: Router
    , private activatedRoute: ActivatedRoute
    , private titleService: Title
    , private _compiler: Compiler
    , private backFilterService: BackFilterService
    , private dataService: DataService
  ) {

    this.getDesignVersion();
    this._compiler.clearCache();
    this.refresh();
    this.titleService.setTitle(AppConfig.settings.applicationSetting.title);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const designVersion = localStorage.getItem('designVersion');
        this.designVersion = designVersion;
        if (event.url === '/forgot_password' || designVersion === 'V2' || event.url === '/loading') {
          this.hideElement = true;
        } else if (event.url !== '/forgot_password') {
          this.hideElement = false;
        }
      }
    });

    //AVOID MULTILOGIN - https://trello.com/c/Cq3C5yWy/708-avoid-multilogin-kcms - Start
    window.onstorage = (a: any) => {
      {
        if (sessionStorage.getItem('isAnyLoginSession') == 'Yes') {
          if (localStorage.getItem('userEmail') != sessionStorage.getItem('userEmail')) {
            this.auth.kashioLogout();
          }
        }
      };
    }
    //AVOID MULTILOGIN - End
  }

  ngOnInit() {
    window.addEventListener('storage', (event) => {
      if (event.storageArea == localStorage) {
        if (localStorage.length == 0) {
          setTimeout(() => {
            this.router.navigate(['/logout']);
          }, 500)
        }
      }
    });

    this.dataService.hideHeader$
      .pipe(takeUntil(this.destroy$))
      .subscribe(hide => {
        this.hideHeaderForComponent = hide;
      });
  }

  getDesignVersion() {
    this.dataService.designVersion$
      .pipe(
        takeUntil(this.destroy$)
      ).subscribe(designVersion => {
        this.designVersion = designVersion;
      });
  }

  refresh() {
    if (sessionStorage.getItem('lastRefreshed') == undefined || sessionStorage.getItem('lastRefreshed') == null) {
      sessionStorage.setItem("lastRefreshed", new Date().toLocaleString());
      location.reload();
    } else {
      sessionStorage.setItem("lastRefreshed", new Date().toLocaleString());
      if (AppConfig.settings.apiServer.baseURL == window.location.href) {
        this.router.navigate(['/callback']);
      } else if (AppConfig.settings.apiServer.baseURL + 'loading' == window.location.href) {
        this.router.navigate(['/callback']);
      }
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.backFilterService.setIsBrowserBackButtonPressedSharedData(true);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
